import { Image, handleEnterKey } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { WebCustomImageAd } from '../../webCustomImageAd/webCustomImageAd';
import type { BannerCarouselSlide } from '../bannerCarousel.types';

import styles from './carouselItem.module.css';

type CarouselItemProps = {
  activeIndex: number;
  index?: number;
  onClick: () => void;
  slide: BannerCarouselSlide;
};

export const CarouselItem = ({
  activeIndex,
  index = 0,
  onClick,
  slide,
}: CarouselItemProps) => {
  if (slide.kind === 'customImageAd') {
    return (
      <div
        className={clsx(styles['innerCarouselItem'])}
        data-testid="carousel-item"
        draggable={false}
      >
        <div className={styles['itemContainer']}>
          <WebCustomImageAd {...slide} />
        </div>
      </div>
    );
  }

  const { fallbackSrc, imageAlt, imageSrc, srcSet, url } = slide;
  const imageObjectFit = 'cover';
  const imageBorderRadius = 'none';
  const isActive = activeIndex === index;
  const isPriority = isActive || Math.abs(activeIndex - index) <= 1;

  const image = (
    <Image
      src={imageSrc}
      srcSet={srcSet}
      altText={imageAlt}
      objectFit={imageObjectFit}
      height="100%"
      borderRadius={imageBorderRadius}
      fallbackSrc={fallbackSrc}
      loading={isPriority ? 'eager' : 'lazy'}
      className={url ? undefined : styles['innerCarouselImg']}
    />
  );

  if (url) {
    return (
      <div
        className={styles['innerCarouselItem']}
        data-testid="carousel-item"
        draggable={false}
      >
        <div className={styles['itemContainer']}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles['innerCarouselImg']}
            onClick={onClick}
          >
            {image}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles['innerCarouselItem']}
      data-testid="carousel-item"
      draggable={false}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyUp={(event) => handleEnterKey(event, onClick)}
    >
      <div className={styles['itemContainer']}>{image}</div>
    </div>
  );
};
